import React from "react";
import { bool, func, string } from "prop-types";

import Icons from "../../icons";
import Input from "../Input";

import "./filter-input.m.css";

const FilterInput = ({
  type = "text",
  placeHolder = "",
  isClear = false,
  className = "",
  value = "",
  readOnly = false,
  onChange = () => {},
  isOpen = false,
  onClear = () => {},
  onInputClick = () => {},
  iconName = "input-down",
  id = "filter-input",
}) => (
  <label styleName="base" className={className} htmlFor={id}>
    <Input
      type={type}
      autoComplete="off"
      onChange={onChange}
      readOnly={readOnly}
      id={id}
      placeHolder=" "
      styleName="input"
      onClick={onInputClick}
      value={value}
    />
    <div styleName="bg" />
    <label styleName="placeholder" htmlFor={id}>
      {placeHolder}
    </label>
    {isClear && value ? (
      <label htmlFor={id}>
        <Icons onClick={onClear} htmlFor="filter-input" type="clear-input" styleName="clear-input" />
      </label>
    ) : (
      <label htmlFor={id}>
        <Icons
          htmlFor="filter-input"
          type={iconName}
          className="filter-input-icon"
          styleName={`input-down ${isOpen ? "up" : ""}`}
        />
      </label>
    )}
  </label>
);

FilterInput.propTypes = {
  className: string,
  type: string,
  placeHolder: string,
  value: string,
  readOnly: bool,
  onChange: func,
  isOpen: bool,
  isClear: bool,
  id: string,
  iconName: string,
  onClear: func,
  onInputClick: func,
};

export default FilterInput;
